import { Route } from "found";

import ImportFromWordPage from "./ImportFromWord";
import ImportFromWordQuery from "./ImportFromWordQuery";

import { ErrorCheckWrapper } from "pstat-anywhere/utils/routes";
import { checkForRedirect } from "pstat-anywhere/utils/urls";


const routes = (
  <Route path="build">
    <Route
      path=""
      query={ImportFromWordQuery}
      Component={ImportFromWordPage}
      data={{
        routeName: "document_build"
      }}
      render={({ props }) => {
        checkForRedirect(props, "documentBuild");
        return (
          <ErrorCheckWrapper queryName="documentBuild" {...props}>
            <ImportFromWordPage {...props} />
          </ErrorCheckWrapper>
        );
      }}
    />
  </Route>
);

export default routes;
